/**
 * Game state shape — mirrors the Firebase Realtime Database structure under `game/`.
 * Consumers read from gameStore.getState(); writes go through src/services/firebase.js.
 */

export const initialGameState = {
  round:    -1,
  active:   false,
  bomb:     false,
  endMs:    0,
  durMs:    0,
  subs:     {},
  scores:   {},
  badges:   {},
  teams:    {},
  returned: {},
  _reset:   0,
};

/**
 * Normalises raw Firebase snapshot data into the expected shape.
 * Guards against null / missing fields from a fresh database.
 * @param {object|null} data
 * @returns {typeof initialGameState}
 */
export function normaliseGameState(data) {
  if (!data) return { ...initialGameState };
  return {
    round:    data.round    ?? -1,
    active:   data.active   ?? false,
    bomb:     data.bomb     ?? false,
    endMs:    data.endMs    ?? 0,
    durMs:    data.durMs    ?? 0,
    subs:     data.subs     ?? {},
    scores:   data.scores   ?? {},
    badges:   data.badges   ?? {},
    teams:    data.teams    ?? {},
    returned: data.returned ?? {},
    _reset:   data._reset   ?? 0,
  };
}
